module.exports = __webpack_public_path__ + "img/shrubs_al.0664115e.svg";